import {
  Typography,
} from "@mui/material";
import { Theme, useTheme } from '@mui/material/styles'
import { createStyles, makeStyles } from '@mui/styles';
import ResponsiveDrawer from "../../components/ClippedResponsiveDrawer";
import { AxiosRequestConfig } from "axios";
import React, { useEffect, useState } from "react";
import { AXIOS_INSTANCE, BASE_URL } from "../../App";
import { useLocalStorage } from "../../utils/LocalStorageHook";
import TableAbstraction from "../../componentUtils/TableAbstraction"
import DateRangeHeader from "./DateRangeHeader";
import {tableHeightReducePx} from "./Header";

interface ReportingState {
  isLoaded: boolean,
  data: ReportingRow[],
}

interface ReportingRow {
  salesOffice: string;
  route: string;
  avgUnits: number;
  fillRate: number;
  numRecords: number;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    centerDiv: {
      textAlign: "center",
    },
    root: {
      padding: theme.spacing(2),
      marginBottom: theme.spacing(2),
    },
    rootContainer: {
      [theme.breakpoints.down("md")]: {
        padding: 0,
        paddingTop: theme.spacing(1),
      },
    },
    tokenBlock: {
      width: "500px",
      overflowWrap: "break-word",
    },
    typography: {
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(1),
    },
  })
);

async function getReportingData(salesOrg: string, deliveringPlants: string[], dateFrom: string, dateTo: string) {
  const configReporting: AxiosRequestConfig = {
    method: "POST",
    params: {
      clientId: "100",
      salesOrg: salesOrg,
    },
    data: {
      "deliveringPlants": deliveringPlants,
      "dateFrom": dateFrom,
      "dateTo": dateTo,
    },
    url: `${BASE_URL}/api/reporting/fillrate`,
  };

  return await AXIOS_INSTANCE(configReporting).then((res: any) => res.data);
}

export default function ConfigurationReporting() {
  const classes = useStyles();
  const [state, setState] = useState<ReportingState>({
    isLoaded: false,
    data: [],
  });

  const [salesOrg,] = useLocalStorage("SETTINGS.salesOrg", "");

  const onSelectionChange = (deliveringPlants: string[], dateFrom: string, dateTo: string) => {
    const sOrg = salesOrg.toString();
    if (deliveringPlants.length > 0) {
      getReportingData(sOrg, deliveringPlants, dateFrom, dateTo)
      .then((v) => {
        setState({isLoaded: true, data: v});
      })
    }
  }


  return (
    <ResponsiveDrawer
      title="Reporting"
    >
      <div className={classes.rootContainer}>
        <DateRangeHeader onSelectionChange={onSelectionChange}/>

        <TableAbstraction
          settingsKey="RPT_FR"
                      options={{
                        serverSide: false,
                        download: false,
                        responsive: "vertical",
                        selectableRows: "none",
                        rowsPerPage: 100,
                        sortOrder: [{ name: "route", direction: "asc" }],
                        tableHeightReducePx,
                      }}
                      title="Average Fill Rate Overview"
                      columns={[
                        // {
                        //   label: "Sales Office",
                        //   name: "salesOffice",
                        // },
                        {
                          label: "Delivery Plant",
                          name: "deliveringPlant",
                        },
                        {
                          label: "Route",
                          name: "route",
                        },
                        {
                          label: "Average Number of Units",
                          name: "avgUnits",
                          options: {
                            searchable: false,
                            filter: false,
                            renderCell: (params) => {
                              if(params.row.avgUnits)
                                return <Typography>{params.row.avgUnits.toFixed(0)}</Typography>;
                            },
                          },
                        },
                        {
                          label: "Average Fill Rate",
                          name: "fillRate",
                          options: {
                            searchable: false,
                            filter: false,
                            renderCell: (params) => {
                              if(params.row.fillRate){
                                const perc = params.row.fillRate * 100;
                                return <Typography>{perc.toFixed(0)}%</Typography>;
                              }
                            },
                          },
                        },
                        {
                          label: "Total Number of Settlements",
                          name: "numRecords",
                        },                                                                                                                                                                                                                                                                   
                      ]}
                      data={state.data}
                    />
      </div>
    </ResponsiveDrawer>
  );
}